<template>
  <div class="contact-directory-header">
    <div class="contact-directory-header__title">
      <div>
        <h1 class="contact-directory-header__page-title">{{ $t('menu.contact-directory') }}</h1>
      </div>
    </div>
    <div v-if="withSearch" class="contact-directory-header__search-bar">
      <ContactDirectorySearchBar @search="search" />
    </div>
  </div>
</template>

<script>
import ContactDirectorySearchBar from '@/components/page-contact-directory/ContactDirectorySearchBar';

export default {
  name: 'TendersHeader',
  components: { ContactDirectorySearchBar },
  props: {
    // Phones show the search under the header, as the other lists do (the page draws it).
    withSearch: { type: Boolean, default: true },
  },
  data() {
    return {
      value: '',
    };
  },
  methods: {
    search(event) {
      this.$emit('search', event);
    },
  },
};
</script>

<style lang="scss">
.contact-directory-header {
  background: $color-white;
  box-shadow: $shadow-dropdown;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: $header-height;
  position: sticky;
  top: $menu-top-bar-height;
  z-index: $header-index;
  padding: 16px 32px;
  gap: 16px;

  &__input {
    border: 1px solid;
    border-radius: 32px;
    padding: 16px;
    margin-bottom: 16px;
  }

  &__title {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 0 1 auto;
  }

  &__page-title {
    color: $color-normal;
    display: flex;
    font-family: $font-family-raleway;
    font-size: $font-size-page-title;
    font-weight: normal;
    padding-right: 60px;
    margin: 0 8px 0 0;
    position: relative;
    text-transform: uppercase;

    &::after {
      background: $color-border;
      content: '';
      display: block;
      height: 50px;
      position: absolute;
      right: 0;
      top: calc(50% - 25px);
      width: 1px;
    }
  }

  &__subtitle {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
  }

  &__search-bar {
    min-width: 450px;
    max-width: 600px;
  }

  @media screen and (max-width: 1080px) {
    gap: 0px;

    &__page-title {
      &::after {
        display: none;
      }
    }
  }

  // Phones: the search under the title, across the screen.
  @include phone-page-header {
    flex-wrap: wrap;
    gap: 8px;
    padding: 12px $phone-page-gutter;
  }

  &__page-title {
    @include phone-page-title;
  }

  &__search-bar {
    @include screen-below('tablet') {
      flex-basis: 100%;
      min-width: 0;
      max-width: none;
    }
  }
}
</style>
